import { SocketService } from '../lib/socket';

export const SOCKET = Symbol('SOCKET');

const socketService = SocketService.getInstance();

export default () => (next: any) => (action: any) => {
    if (!action) {
        return next(action);
    }
    const socketAction = (action as any)[SOCKET];

    if (!socketAction) {
        return next(action);
    }
    const {type, event, data, successType, errorType, attached} = socketAction;

    switch (type) {
        case 'CONNECT': {
            const authString: any = localStorage.auth;
            const auth: any = JSON.parse(authString);
            return socketService.connect(auth.access_token).then(() => {
                next({
                    type: successType,
                });
            }).catch((error: any) => {
                next({
                    type: errorType,
                    error,
                });
            });
        }
        case 'EMIT': {
            return socketService.emit(event, ...data).then((response: any) => {
                next({
                    type: successType,
                    attached,
                    response,
                });
            }).catch((error: any) => {
                next({
                    type: errorType || 'SOCKET_ERROR',
                    error,
                });
            });
        }
        default: {console.log(); }
    }
};



// WEBPACK FOOTER //
// ./src/middlerware/socket.ts